package meineglasfaser.api

import kotlinx.serialization.Serializable

@Serializable
data class YaTableOptions(
    private val page: Int,
    private val perPage: Int,
    private val orderBy: List<SortPair> = emptyList(),
    private val filters: List<FilterPair> = emptyList(),
    private val searchTerm: String? = null,
) {
    fun page() = page.coerceAtLeast(1)

    fun perPage() = perPage.coerceIn(1, 100)

    fun orderBy() = orderBy.ifEmpty { DEFAULT_ORDER_BY }

    fun filters() = filters.ifEmpty { emptyList() }

    fun searchTerm() = searchTerm

    enum class SortOrder {
        ASC,
        DESC;
    }

    @Serializable
    data class SortPair(
        val colName: String,
        val dir: SortOrder,
    )

    @Serializable
    data class FilterPair(
        val colName: String,
        val searchTerm: String? = null,
        val onlyValues: List<String> = emptyList(),
    )

    companion object {
        val DEFAULT = YaTableOptions(
            page = 1,
            perPage = 25,
        )

        val DEFAULT_ORDER_BY = listOf(SortPair("id", SortOrder.ASC))
    }
}

@Serializable
data class YaTableResult<T>(
    val total: Int,
    val options: YaTableOptions,
    val data: List<T>,
)
